module.exports = __webpack_public_path__ + "img/fengcai2.7d5c2233.png";